<template>
  <div>
    <RegenerateBillModal @refetch-data="$emit('refetch-data')" />
    <div class="d-flex justify-content-between align-items-center mb-2">
      <b-button
        v-if="!tripInfoLoading.bill"
        :disabled="isBillGenerated"
        type="submit"
        variant="primary"
        size="sm"
        @click="$bvModal.show('regenerate-bill-modal')"
      >
        Regenerate Bill
      </b-button>
      <b-badge
        v-if="isEPayment && !isNFCFailure"
        variant="success"
      >
        Paid by NFC (success)
      </b-badge>
      <b-badge
        v-if="!isEPayment && isNFCFailure"
        variant="danger"
      >
        Paid by NFC (Failed) and collected cash
      </b-badge>
      <b-badge
        v-if="!isEPayment && !isNFCFailure"
        variant="info"
      >
        Paid by Cash
      </b-badge></div>
    <b-card>
      <b-row>
        <b-col
          v-for="(el, idx) in tripDetailsEta"
          :key="idx"
          md="6"
        >
          <h4>{{ el.name }}</h4>
          <span>{{ el.value }}</span>
        </b-col>
      </b-row>
    </b-card>
    <b-card>
      <b-card-title class="d-flex justify-content-between">
        <h3 class="mb-0">
          Bill Configuration And Inputs
        </h3>
        <b-button
          v-if="tripVersionId && !showEditBill && $can('write', 'bill-modifications')"
          :disabled="billModofied"
          variant="primary"
          size="sm"
          @click="showEditBill = true;modifyingCollectedAmount = true"
        >
          {{ billModofied ? 'BILL MODIFIED' : 'Modify Bill' }}
        </b-button>
        <b-button
          v-if="tripVersionId && showEditBill && $can('write', 'bill-modifications')"
          variant="primary"
          size="sm"
          @click="modifyDistanceAndTime"
        >
          Update Bill
        </b-button>
        <b-button
          v-if="tripVersionId && showEditBill && $can('write', 'bill-modifications')"
          variant="danger"
          size="sm"
          @click="showEditBill = false"
        >
          Cancel Edit
        </b-button>
        <b-button
          v-if="tripVersionId"
          size="sm"
          @click="navigateToPricingVersion"
        >
          Pricing Version
        </b-button>
      </b-card-title>
      <hr>
      <base-overlay :show="tripInfoLoading.bill">
        <div class="d-flex">
          <div class="trip-configuration__wrapper">
            <template
              v-for="(el, idx) in billConfigAndInputsData"
            >
              <span :key="idx + el.name">{{ el.name }}</span>
              <span :key="idx + el.value">
                <span v-if="el.editable && showEditBill && el.keyName == 'total_distance'">
                  <b-form-input
                    v-model="editDistanceValue"
                    maxlength="4"
                  />
                </span>
                <span v-if="el.editable && showEditBill && el.keyName == 'total_time'">
                  <b-form-input
                    v-model="editTimeValue"
                    maxlength="4"
                  />
                </span>
                {{ el.value }}
              </span>
            </template>
          </div>
          <div class="d-flex flex-column">
            <bill-slicing :slices="timeSlices" />
            <bill-slicing
              :slices="distanceSlices"
              slicing-type="distance"
            />
            <bill-slicing
              :slices="journeyWaitTimeSlices"
              slicing-type="journey"
            />
          </div>
        </div>
      </base-overlay>

    </b-card>
    <div class="d-flex justify-content-center">
      <b-card
        style="width:35%"
        class="mr-5"
      >
        <b-card-title>
          <h3>User Bill Details</h3>
        </b-card-title>
        <hr>
        <base-overlay :show="tripInfoLoading.bill">
          <div>
            <table>
              <thead>
                <tr>
                  <th>
                    <h4 class="font-weight-bolder">
                      Price Details
                    </h4>
                  </th>
                  <th />
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(el, idx) in actualBillDetailsData"
                  :key="idx"
                >
                  <td> {{ el.name }} </td>
                  <td
                    class="d-flex justify-content-end"
                    :class="{'text-success': el.colored}"
                  >
                    {{ (el.value || el.value === 0) ? el.value : '_' }}
                  </td>
                </tr>
              </tbody>
            </table>
            <hr>
            <div
              v-for="(el, ix) in userExtraBillInfo"
              :key="ix"
              class="d-flex justify-content-between"
            >
              <h5>{{ el.name }}</h5>
              <template
                v-if="el.tooltipMessage"
              >
                <b-tooltip
                  :target="`user${el.name+ix}`"
                  triggers="hover"
                >
                  {{ el.tooltipMessage }}
                </b-tooltip>
                <feather-icon
                  :id="`user${el.name+ix}`"
                  icon="InfoIcon"
                  size="12"
                />

              </template>
              <span :class="el.color ? `text-${el.color}` : ''">{{ el.value }}</span>
            </div>
            <hr>
            <div
              v-for="(el, ix) in userCash"
              :key="ix + 'user-bill'"
              class="d-flex justify-content-between"
            >
              <h5>{{ el.name }}</h5>
              <span :class="el.color ? `text-${el.color}` : ''">{{ el.value }}</span>

            </div>
          </div>
        </base-overlay>
      </b-card>
      <b-card style="width:35%">
        <b-card-title>
          <h3>Driver Bill Details</h3>
        </b-card-title>
        <hr>
        <base-overlay :show="tripInfoLoading.bill">
          <div>
            <table>
              <thead>
                <tr>
                  <th>
                    <h4 class="font-weight-bolder">
                      Price Details
                    </h4>
                  </th>
                  <th />
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(el, idx) in actualBillDetailsData"
                  :key="idx"
                >
                  <td> {{ el.name }} </td>
                  <td
                    class="d-flex justify-content-end"
                  >
                    {{ (el.value || el.value === 0) ? el.value : '_' }}
                  </td>
                </tr>
              </tbody>
            </table>
            <hr>
            <div
              v-for="(el, ix) in driverExtraBillInfo"
              :key="ix"
              class="d-flex justify-content-between"
            >
              <h5>{{ el.name }}</h5>
              <template
                v-if="el.tooltipMessage"
              >
                <b-tooltip
                  :target="`${el.name+ix}`"
                  triggers="hover"
                >
                  {{ el.tooltipMessage }}
                </b-tooltip>
                <feather-icon
                  :id="`${el.name+ix}`"
                  icon="InfoIcon"
                  size="12"
                />

              </template>
              <span :class="el.color ? `text-${el.color}` : ''">{{ el.value }}</span>
            </div>
            <hr>
            <div
              v-for="(el, ix) in driverBalances"
              :key="ix + el.name"
              class="d-flex justify-content-between"
            >
              <h5>{{ el.name }}</h5>
              <div>
                <b-button
                  v-if="el.editable && $can('write', 'bill-modifications')"
                  variant="flat-primary"
                  class="p-0 mr-1"
                  :disabled="billModofied"
                  @click="modifyingCollectedAmount = !modifyingCollectedAmount"
                >
                  <feather-icon
                    v-if="!modifyingCollectedAmount"
                    icon="Edit2Icon"
                  />
                  <feather-icon
                    v-else
                    icon="XIcon"
                  />
                </b-button>
                <span
                  :class="el.color ? `text-${el.color}` : ''"
                >{{ el.value }}</span>
              </div>

              <div
                v-if="el.editable && modifyingCollectedAmount"
                class="d-flex align-items-center"
              >
                <b-form-input
                  v-model="editCollectedAmountValue"
                  class="mx-1"
                  size="sm"
                  maxlength="4"
                />
                <b-button
                  variant="primary"
                  size="sm"
                  @click="modifyDistanceAndTime"
                >
                  Save
                </b-button>
              </div>
            </div>
          </div>
        </base-overlay>
      </b-card>
    </div>

    <div
      v-if="billModofied"
      class="d-flex justify-content-center"
    >
      <b-card
        style="width:35%"
        class="mr-5"
      >
        <b-card-title>
          <h3>Modified Bill</h3>
        </b-card-title>
        <hr>
        <base-overlay :show="tripInfoLoading.bill">
          <div>
            <table>
              <thead>
                <tr>
                  <th>
                    <h4 class="font-weight-bolder">
                      Before Modification
                    </h4>
                  </th>
                  <th />
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(el, idx) in beforeBillModifications"
                  :key="idx"
                >
                  <td> {{ el.name }} </td>
                  <td
                    class="d-flex justify-content-end"
                    :class="{'text-success': el.colored}"
                  >
                    {{ (el.value || el.value === 0) ? el.value : '_' }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </base-overlay>
      </b-card>
      <b-card
        style="width:35%"
        class="mr-5"
      >
        <b-card-title>
          <h3>Modified Bill</h3>
        </b-card-title>
        <hr>
        <base-overlay :show="tripInfoLoading.bill">
          <div>
            <table>
              <thead>
                <tr>
                  <th>
                    <h4 class="font-weight-bolder">
                      After Modification
                    </h4>
                  </th>
                  <th />
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(el, idx) in afterBillModifications"
                  :key="idx"
                >
                  <td> {{ el.name }} </td>
                  <td
                    class="d-flex justify-content-end"
                    :class="{'text-success': el.colored}"
                  >
                    {{ (el.value || el.value === 0) ? el.value : '_' }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </base-overlay>
      </b-card>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from 'vue'
import axiosIns from '@/libs/axios'
import {
  BCard, BCardTitle, BButton, BFormInput, BTooltip, BRow, BCol, BBadge,
} from 'bootstrap-vue'
import {
  ref, watch, inject, computed,
} from '@vue/composition-api'
import billSlicing from './BillSlicing.vue'
import RegenerateBillModal from './regenerate-bill/RegenerateBillModal.vue'

export default {
  components: {
    BCard,
    BCardTitle,
    BBadge,
    billSlicing,
    BButton,
    RegenerateBillModal,
    BRow,
    BCol,
    BTooltip,
    BFormInput,
  },
  props: {
    tripBillDetails: {
      type: Object,
      default: undefined,
    },
  },

  setup(props, ctx) {
    
    const columns = [
      {
        label: '',
        key: 'name',
      },
      {
        label: '',
        key: 'value',
      },
    ]
    const trip = inject('trip')
    const isBillGenerated = ref(false)
    const tripInfoLoading = inject('tripInfoLoading')
    const billConfigAndInputsData = ref([])
    const actualBillDetailsData = ref([])
    const billCreationTime = ref(null)
    const timeSlices = ref([])
    const distanceSlices = ref([])
    const journeyWaitTimeSlices = ref([])
    const tripVersionId = ref(null)
    const upfrontEstimates = ref({})
    const billModofied = ref(false)
    const billMeta = ref({})
    const userExtraBillInfo = ref([])
    const driverExtraBillInfo = ref([])
    const driverBalances = ref([])
    const userTotalCash = ref(0)
    const userCash = ref([])
    const modifyingCollectedAmount = ref(false)
    const showEditBill = ref(false)
    const showEditCollectedAmount = ref(false)
    const beforeBillModifications = ref([])
    const afterBillModifications = ref([])
    const editDistanceValue = ref(null)
    const editTimeValue = ref(null)
    const editCollectedAmountValue = ref(null)
    const isEPayment = ref(false)
    const isNFCFailure = ref(false)


    const tripDetailsEta = computed(() => {
      let arr = []
      if (trip.value) {
        const { metadata } = trip.value
        const {
          eta
        } = metadata
        arr = [
          { value: eta?.price?.fare?.details?.time_slicings?.amount ? `${eta.price.fare.details.time_slicings.amount?.toFixed(3)} $` : '_', name: 'Estimate Time Price' },
          { value: eta?.price?.fare?.details?.distance_slicings?.amount ? `${eta.price.fare.details.distance_slicings.amount?.toFixed(3)} $` : '_', name: 'Estimate Distance Price ' },
        ]
      }
      return arr
    })

    watch(() => props.tripBillDetails, newVal => {
      
      isBillGenerated.value = Object.keys(newVal).length > 0
      if (newVal) {
        const meta = newVal?.meta

        billMeta.value = meta
        billModofied.value = newVal?.modified
        tripVersionId.value = meta?.pricing_version_id
        billCreationTime.value = meta?.inbound_data?.inputs?.create_time
        timeSlices.value = meta?.details?.fare?.details?.time_slicings?.slices
        distanceSlices.value = meta?.details?.fare?.details?.distance_slicings?.slices
        journeyWaitTimeSlices.value = meta?.details?.fare?.details?.journey_wait_time?.slices
        upfrontEstimates.value = meta?.details?.fare?.details?.upfront_estimates?.details

        // Determine payment method
        isNFCFailure.value = meta?.nfc_payment_failure || false
        isEPayment.value = !!(meta?.details?.paid_by_visa && trip.value?.payment_method_id)
        actualBillDetailsData.value = [
          {
            name: 'Open Meter Amount',
            value: meta?.details?.fare?.details?.open_meter_amount,
          },
          {
            name: 'Distance Price',
            value: meta?.details?.fare?.details?.distance_slicings?.amount?.toFixed(3),
          },
          {
            name: 'Time Price',
            value: meta?.details?.fare?.details?.time_slicings?.amount?.toFixed(3),
          },
          {
            name: 'Total Pending Fees',
            value: meta?.details?.fees?.details?.pending_transactions?.total,
          },
          {
            name: 'Drop Out Of Zone',
            value: meta?.details?.fees?.details?.drop_zone?.amount,
          },
          {
            name: 'Arrival Charge',
            value: meta?.details?.fare?.details?.arrival_charge?.amount,
          },
          {
            name: 'Tax Amount',
            value: meta?.details?.fare?.details?.tax_amount,
          },
        ]
        const subTotalResult = actualBillDetailsData.value.reduce((prev, curr) => {
          if (curr.value) return +prev + Number(curr.value)
          return 0
        }, 0)
        const subTotalValue = subTotalResult < newVal.total ? newVal.total : subTotalResult
        userExtraBillInfo.value = [
          {
            name: 'Sub-Total',
            value: +subTotalValue?.toFixed(2),
          },
          {
            name: `Promo Code Amount ${trip.value?.metadata?.promo?.coupon ? `(${trip.value?.metadata?.promo?.coupon})` : ''}`,
            value: meta?.details?.promo?.amount,
            color: 'danger',
            tooltipMessage: meta?.details?.promo?.message
          },
          {
            name: 'Session discount',
            value: meta?.details?.session_discount?.discount_amount || 0,
            color: 'danger',
          },
          {
            name: 'Paid by wallet',
            value: meta?.details?.paid_by_wallet,
            color: 'danger',
          },
          {
            name: 'Paid by visa',
            value: meta?.details?.paid_by_visa,
            color: 'danger',
          },
          {
          name: 'Extra Payment',
          value: meta?.details?.extra_payment?.amount ? +meta?.details?.extra_payment?.amount : 0 ,
          color: 'danger',
        },
        ]
        userTotalCash.value = userExtraBillInfo.value.reduce((prev, curr) => {
          if (curr.color) {
            return prev - +curr.value?.toFixed(3)
          }
          return +curr.value?.toFixed(3)
        }, 0)
        driverExtraBillInfo.value = [...userExtraBillInfo.value.map(el => ({
          ...el,
          color: el.color ? 'success' : undefined,
        })),
        {
          name: 'Admin Commission',
          value: +(((meta?.details.fees?.details?.drop_zone?.amount ? meta?.details.fees?.details?.drop_zone?.amount : 0) + meta?.details?.fare?.total) * meta?.details?.fare?.details?.admin_commission).toFixed(2),
          color: 'danger',
        },
        {
          name: 'Faraway Amount',
          value: trip.value?.metadata?.faraway_bonus_amount ? +trip.value?.metadata?.faraway_bonus_amount : 0 ,
          color: 'success',
        },
        {
          name: 'Waiting time price',
          value: meta?.details?.fare?.details?.journey_wait_time?.amount ? +meta?.details?.fare?.details?.journey_wait_time?.amount : 0 ,
          color: 'success',
        },

        ]
        userCash.value = [
          {
            name: 'Bill Amount',
            value: userTotalCash.value > 0 ? userTotalCash.value : 0,
            color: 'success',
          },
          {
            name: 'Collected Amount',
            value: newVal?.collected_amount,
            color: 'success',
          },
        ]
        driverBalances.value = [
          {
            name: 'Collected Amount',
            editable: true,
            value: newVal?.collected_amount,
            color: 'success',
          },
          {
            name: 'Driver balance after accepting the trip',
            value: meta?.details?.driver_wallet?.balance,
          },
          {
            name: 'Driver balance after collecting the amount',
            value: meta?.driver_wallet?.balance ? meta?.driver_wallet?.balance : '_',
          },
        ]
        billConfigAndInputsData.value = [
          {
            name: 'Pick Up Zone',
            editable: false,
            value: meta?.inbound_data?.zone?.split('::')[1],
          },
          {
            name: 'Minimum Amount',
            editable: false,
            value: meta?.details?.fare?.details?.minimum_amount,
          },
          {
            name: 'Drop Zone',
            editable: false,
            value: meta?.inbound_data?.inputs?.drop_zone?.split('::')[1],
          },
          {
            name: 'Peak Factors',
            editable: false,
            value: meta?.details?.fare?.details?.peak_factors && Object.values(meta?.details?.fare?.details?.peak_factors)
              .reduce((prev, curr, idx) => `${prev} Factor ${idx + 1} : ${curr},`,
                ''),
          },
          {
            name: 'Total Time',
            keyName: 'total_time',
            value: meta?.inbound_data?.inputs?.total_time && `${meta?.inbound_data?.inputs?.total_time} Seconds ${(meta?.inbound_data?.inputs?.total_time / 60).toFixed(3)} Minutes`,
            editable: true,
            modifiedValue: '',
          },
          {
            name: 'Total Distance',
            keyName: 'total_distance',
            value: meta?.inbound_data?.inputs?.total_distance && `${meta?.inbound_data?.inputs?.total_distance?.toFixed(3)} KM`,
            editable: true,
            modifiedValue: '',
          },
        ]
        beforeBillModifications.value = [{
          name: 'Before Bill Total',
          value: meta?.modified_details?.before_bill_total,
        },{
          name: 'Before Bill Admin Commission',
          value: meta?.modified_details?.before_total_commission,
        },{
          name: 'Before Total Time',
          value: meta?.inbound_data?.inputs?.total_time && `${meta?.inbound_data?.inputs?.total_time} Seconds ${(meta?.inbound_data?.inputs?.total_time / 60).toFixed(3)} Minutes`,
        },{
          name: 'Before Total Distance',
          value: meta?.inbound_data?.inputs?.total_distance && `${meta?.inbound_data?.inputs?.total_distance?.toFixed(3)} KM`,
        },]
        afterBillModifications.value = [{
          name: 'After Bill Total',
          value: meta?.modified_details?.after_bill_total,
        },{
          name: 'After Bill Admin Commission',
          value: meta?.modified_details?.after_total_commission,
        },{
          name: 'After Total Time',
          value: meta?.modified_details?.new_inputs?.total_time && `${meta?.modified_details?.new_inputs?.total_time} Seconds ${(meta?.modified_details?.new_inputs?.total_time / 60).toFixed(3)} Minutes`,
        },{
          name: 'After Total Distance',
          value: meta?.modified_details?.new_inputs?.total_distance && `${meta?.modified_details?.new_inputs?.total_distance?.toFixed(3)} KM`,
        },]
      }

    })
    const navigateToPricingVersion = () => window.open(`${window.location.origin}/versions/edit/${tripVersionId.value}`)
    
    const modifyDistanceAndTime = async () => {
      const result = await Vue.swal({
          title: 'Are you sure?',
          text: 'You want to apply this action?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, update it!',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
      })
      if (result.value) {
        const res = await axiosIns.patch(`bills/snapshots/modify/${props.tripBillDetails.id}`, {
          total_distance: editDistanceValue.value,
          total_time: editTimeValue.value,
          collected_amount: editCollectedAmountValue.value,
        })
        ctx.emit('refetch-data');
      }
      editDistanceValue.value = null
      editTimeValue.value = null
      editCollectedAmountValue.value = null
    }
    return {
      navigateToPricingVersion,
      columns,
      billConfigAndInputsData,
      actualBillDetailsData,
      billCreationTime,
      timeSlices,
      distanceSlices,
      isBillGenerated,
      journeyWaitTimeSlices,
      tripVersionId,
      trip,
      tripInfoLoading,
      userCash,
      userTotalCash,
      driverBalances,
      userExtraBillInfo,
      driverExtraBillInfo,
      showEditBill,
      showEditCollectedAmount,
      editDistanceValue,
      editTimeValue,
      billModofied,
      modifyDistanceAndTime,
      beforeBillModifications,
      afterBillModifications,
      modifyingCollectedAmount,
      editCollectedAmountValue,
      tripDetailsEta,
      isEPayment,
      isNFCFailure,
    }
  },

}
</script>

<style scoped>
table {
  width:100%
}
table td,
table th {
  padding-bottom: 10px;
  font-size: 16px;
}
table td {
  font-weight: normal;
}
table th {
  font-size: 18px;
}
.trip-configuration__wrapper {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  column-gap: 80px;
}
</style>
